import type { AfterNavigate, BeforeNavigate, OnNavigate } from '@sveltejs/kit';
import type { SvelteClient } from '$lib/svelte/SvelteClient';
import { delay } from '$lib/utils/delay';
import type { MaybePromise } from '$lib/utils/promise';

const afterNavigate = ((
    _callback: (navigation: AfterNavigate) => void,
) => {}) satisfies SvelteClient['afterNavigate'];

const beforeNavigate = ((
    _callback: (navigation: BeforeNavigate) => void,
) => {}) satisfies SvelteClient['beforeNavigate'];

const disableScrollHandling = (() => {}) satisfies SvelteClient['disableScrollHandling'];

const goto = (async (
    url: string | URL,
    _opts?: {
        replaceState?: boolean;
        noScroll?: boolean;
        keepFocus?: boolean;
        invalidateAll?: boolean;
        state?: any; // eslint-disable-line @typescript-eslint/no-explicit-any
    },
) => {
    window.location.assign(url);
    await delay(10);
    return;
}) satisfies SvelteClient['goto'];

const invalidate = (async (
    _url: string | URL | ((url: URL) => boolean),
) => {}) satisfies SvelteClient['invalidate'];

const invalidateAll = (async () => {}) satisfies SvelteClient['invalidateAll'];
const invalidateAllDebounced = ((
    _ms: number,
) => {}) satisfies SvelteClient['invalidateAllDebounced'];

const onNavigate = ((
    _callback: (navigation: OnNavigate) => MaybePromise<(() => void) | void>,
) => {}) satisfies SvelteClient['onNavigate'];

const preloadCode = (async (_url: string) => {}) satisfies SvelteClient['preloadCode'];

const preloadData = (async (
    _href: string,
): Promise<
    | {
          type: 'loaded';
          status: number;
          data: Record<string, any>; // eslint-disable-line @typescript-eslint/no-explicit-any
      }
    | {
          type: 'redirect';
          location: string;
      }
> => {
    throw new Error('impossible of preloadData in SvelteClientLegacy');
}) satisfies SvelteClient['preloadData'];

export const svelteClientLegacy: SvelteClient = {
    afterNavigate,
    beforeNavigate,
    disableScrollHandling,
    goto,
    invalidate,
    invalidateAll,
    invalidateAllDebounced,
    onNavigate,
    preloadCode,
    preloadData,
} satisfies SvelteClient;
